import React from 'react';
import { Typography } from 'antd';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Title } from '~/components';
import paths from '~/pages/paths';
import { useAcceptInvitation } from '~/controllers/invitation';
import { ConfirmButton } from '~/layouts/ksa/CompanyInfoLayout';

const AcceptInvitation: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation('ksaOnboarding');
  const acceptInvitation = useAcceptInvitation();

  const onAcceptClick = () => {
    acceptInvitation
      .mutateAsync()
      .then(() => {
        history.push(paths.home._);
      })
      .catch(() => {
        history.push(paths.ksa.invitation.error.replace(':errorType', 'default'));
      });
  };

  return (
    <div>
      <Title text={t('Get started')} subtext={t('with {{BRANDING_NAME}}')} />
      <SubTitle>{t('Great! The onboarding journey will take you about 30 minutes.')}</SubTitle>

      <ConfirmButton
        id="acceptInvitation_accept"
        type="primary"
        htmlType="submit"
        loading={acceptInvitation.isLoading}
        onClick={onAcceptClick}
      >
        {t('Let’s start!')}
      </ConfirmButton>
    </div>
  );
};

const SubTitle = styled(Typography.Paragraph)`
  margin-bottom: 32px !important;
`;

export default AcceptInvitation;
